import type { Choice } from '@monthio/react-components/dist/MultipleChoice'
import type { FormikProps } from 'formik'

import { FormMultipleChoice, makeStyles } from '@monthio/react-components'
import i18next from 'i18next'
import React from 'react'
import styled from 'styled-components'

import type { BudgetHelperQuestionnaireInputs } from '../../../types'
import type { StepKey } from './steps'

export const MultipleChoiceWrapper = styled.div<{ $columns: number }>`
	width: 100%;
	& > div > div {
		display: grid;
		grid-gap: 8px;
		grid-template-columns: repeat(${(props) => props.$columns}, 1fr);
		margin: 0;
	}

	${(props) => props.theme.breakpoints.up('sm')} {
		width: 480px;
	}
`
export const useStyles = makeStyles(() => ({
	button: {
		'& > label': {
			minWidth: 'auto',
			height: '50px',
			padding: '0px',
			borderRadius: '4px',
			margin: '0px',
		},
	},
	root: {
		width: 'auto',
	},
}))

interface MultipleChoiceProps {
	id: StepKey
	choices?: Choice[]
	invalidAnswer?: string
	setIsInvalid?: (event: any) => void
	handleClick: (value: StepKey) => void
	formProps: FormikProps<BudgetHelperQuestionnaireInputs>
}

export enum Alternative {
	YES = 'Yes',
	NO = 'No',
}

const yesNoChoices = () => [
	{ value: Alternative.YES, label: i18next.t('btn-yes') },
	{ value: Alternative.NO, label: i18next.t('btn-no') },
]

const StyledFormMultipleChoice = styled(FormMultipleChoice)`
	width: 100%;
	justify-content: stretch;
`

export const StepMultipleChoice: React.FC<MultipleChoiceProps> = ({
	id,
	choices = yesNoChoices(),
	invalidAnswer,
	setIsInvalid,
	handleClick,
	formProps,
}) => {
	const classes = useStyles()

	return (
		<MultipleChoiceWrapper $columns={2}>
			<StyledFormMultipleChoice
				id={id}
				choices={choices}
				fieldName={id}
				className={`${classes.root} ${classes.button}`}
				choiceAlign="center"
				onClick={(event: any) => {
					if (event.target.value === invalidAnswer) {
						setIsInvalid?.(true)
					} else {
						handleClick(event.target.value)
					}
				}}
				selected={
					formProps.values[
						id as keyof BudgetHelperQuestionnaireInputs
					] as string
				}
			/>
		</MultipleChoiceWrapper>
	)
}
